var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFaPlusSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.077,51.077a3.077,3.077,0,0,0-6.154,0V64.923H19.077a3.077,3.077,0,1,0,0,6.154H32.923V84.923a3.077,3.077,0,0,0,6.154,0V71.077H52.923a3.077,3.077,0,0,0,0-6.154H39.077Z",
    transform: "translate(-16 -48)",
    fill: "#222"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaPlusSolid);
export default __webpack_public_path__ + "static/media/faPlusSolid.8bfaf077d8dd814daf28c37bb7ce7456.svg";
export { ForwardRef as ReactComponent };